"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypographyNameLink = exports.DarkBackgroundLink = exports.SecondaryLink = exports.PrimaryLink = exports.StyledLink = void 0;
var material_1 = require("@mui/material");
var system_1 = require("@mui/system");
var colors_1 = require("../ThemeProvider/colors");
exports.StyledLink = (0, system_1.styled)(material_1.Link)(function () { return ({
    '&:focus-visible': {
        outline: "3px solid ".concat(colors_1.tannerSemantic['info'].color),
        outlineOffset: '3px',
        borderRadius: '3px',
        transition: 'outline-offset 150ms',
    },
}); });
exports.PrimaryLink = (0, system_1.styled)(exports.StyledLink)(function (_a) {
    var context = _a.context;
    return ({
        color: colors_1.tannerSemantic['info'].color,
        textDecoration: context === 'explicit' ? 'underline' : 'none',
        '&:hover': {
            textDecoration: 'underline',
            color: context === 'explicit' ? '#0049AB' : colors_1.tannerSemantic['info'].color,
        },
    });
});
exports.SecondaryLink = (0, system_1.styled)(exports.StyledLink)(function (_a) {
    var context = _a.context;
    return ({
        color: colors_1.tannerBlack,
        textDecoration: context === 'explicit' ? 'underline' : 'none',
        '&:hover': {
            textDecoration: 'underline',
            color: context === 'explicit' ? colors_1.tannerGray['600'] : colors_1.tannerBlack,
        },
    });
});
exports.DarkBackgroundLink = (0, system_1.styled)(exports.StyledLink)(function (_a) {
    var context = _a.context;
    return ({
        color: colors_1.tannerWhite,
        backgroundColor: colors_1.tannerBlack,
        textDecoration: context === 'explicit' ? 'underline' : 'none',
        '&:hover': {
            textDecoration: 'underline',
            color: context === 'explicit' ? colors_1.tannerGray['300'] : colors_1.tannerWhite,
        },
    });
});
exports.TypographyNameLink = (0, system_1.styled)(exports.StyledLink)(function (_a) {
    var context = _a.context;
    return ({
        color: colors_1.tannerBlack,
        fontWeight: context === 'explicit' ? 800 : 500,
        '&:hover': {
            textDecoration: 'underline',
            color: colors_1.tannerBlack,
        },
    });
});
//# sourceMappingURL=styles.js.map